export const getQueryFormattedDate = (date: Date | string | number) => {
  const result = new Date(date);
  const month = (result.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 because months are zero-based
  const day = result.getDate().toString().padStart(2, '0');
  const year = result.getFullYear();
  return `${month}-${day}-${year}`;
}



export const getPostFormattedDate = (date: Date | string | number, locale: string) => {
  const result = new Date(date);
  const day = result.getDate()
  const month = result.getMonth();
  const year = result.getFullYear();
  return `${day} ${localizedMonths[locale][month]} ${year}`;
}



export const normalizeIsoDate = (iso: string) => iso.endsWith('Z') ? iso : `${iso}Z`;


export const localizedMonths: { [lang in 'en' | 'ar']: string[] } = {
  en: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  ar: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}